export default __webpack_public_path__ + "static/media/we-wish-you.3d72cddd.mp3";